import { render, staticRenderFns } from "./TextareaWithToolbar.vue?vue&type=template&id=159bcd0d&"
import script from "./TextareaWithToolbar.vue?vue&type=script&lang=js&"
export * from "./TextareaWithToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports